// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar_container__v3qie {
  background-color: #22835f;
  left: 0;
  top: 0;
  right: 0;
  z-index: 2;
  position: fixed;
}

.navbar_hide__8qNbu {
  margin-top: -3em;
  transition-duration: 200ms;
}
.navbar_show__UXp4Z {
  margin-top: 0;
  transition-duration: 200ms;
}

.navbar_menuButton__EPjGt {
  padding: 0.5em;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 2.5em;
  height: 2em;
}
.navbar_menuButton__EPjGt div {
  padding: 0.2em 0.5em;
  background-color: white;
  /* border-radius : 1em; */
  transition-duration: 200ms;
}

.navbar_open__bl92B .navbar_top__\\+HI2k {
  transform: translate(0, 0.8em) rotate(45deg);
  transition-duration: 200ms;
}
.navbar_open__bl92B .navbar_down__dRLpL {
  transform: translate(0, -0.8em) rotate(-45deg);
  transition-duration: 200ms;
}
.navbar_open__bl92B .navbar_mid__zWmza {
  opacity: 0;
  transform: translate(-1em, 0);
  transition-duration: 200ms;
}

.navbar_mainBar__H50ol {
  display: flex;
  /* justify-content : space-between; */
}

.navbar_linkList__-rNRS {
  position: absolute;
  background-color: #2d3436;
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 0 0 1em 1em;
  overflow: hidden;
}
.navbar_linkList__-rNRS a {
  padding: 1em 2em;
  text-align: start;
  text-decoration: none;
  background-color: #2d3436;
  font-weight: 600;
  color: white;
  border-bottom: 1px solid #8395a7;
}

.navbar_openList__DWbi5 {
  left: 0;
  transition-duration: 200ms;
}

.navbar_closeLink__lzizO {
  left: -100%;
  transition-duration: 200ms;
}

.navbar_unhidden__78CIS {
  display: flex;
}

.navbar_hidden__v3vjP {
  display: none;
}

.navbar_dropdownLinks__FtJBf {
  flex-direction: column;
  padding-left: 2em;
}

.navbar_link__SztSH button {
  color: white;
  padding: 1em 2em;
  background: none;
  width: 100%;
  border: none;
  display: flex;
  font-weight: 600;
  border-bottom: 1px solid #8395a7;
  font-size: 0.95em;
}

.navbar_arrHidden__HaPRv {
  transform: rotate(0);
  transition-duration: 300ms;
}

.navbar_arrUnhidden__3R6EE {
  transform: rotate(90deg);
  transition-duration: 300ms;
}

.navbar_profile__xT7\\+H {
  display: flex;
  margin-right: 1em;
  position: relative;
  margin-left: auto;
}

.navbar_profileDropdown__Z9X5t {
  position: absolute;
  top: 3.8em;
  right: 0;
  transition-duration: 300ms;
  flex-direction: column;
  background: #055437;
  /* background : #00b894; */
  padding: 0.7em 1em;
  border-radius: 0 0 0.5em 0.5em;
  display: flex;
}
.navbar_profShow__xHEmN {
  margin-right: 0em;
  opacity: 1;
}
.navbar_profHide__SsP7k {
  margin-right: -100%;
  opacity: 0;
}
.navbar_profileDropdown__Z9X5t a,
.navbar_profileDropdown__Z9X5t button {
  text-decoration: none;
  color: white;
  font-weight: 600;
  text-align: start;
  display: flex;
  padding: 0.2em 0;
  transition-duration: 150ms;
  background: none;
  border: none;
  font-size: 1.1em;
}
.navbar_profileDropdown__Z9X5t a:hover,
.navbar_profileDropdown__Z9X5t button:hover {
  color: #ffeaa7;
}
.navbar_icon__aXGXB {
  width: 2em;
}

.navbar_imgContainer__iAVW2 {
  display: flex;
  padding: 0.5em;
}
.navbar_imgContainer__iAVW2 img {
  border-radius: 50%;
  border: 2px solid white;
  margin: auto;
}

.navbar_nameContainer__PWQmv {
  display: flex;
  margin: auto;
  color: white;
  border: none;
  background: none;
  font-size: 1.1em;
}

.navbar_churchButton__i0K7x {
  margin: 0.7em 0.5em;
  /* padding : .8em 1em; */
  border: 2px solid #81ecec;
  border-radius: 1em;
  /* color : #055437; */
  color: #ffff;
  background: none;
  cursor: pointer;
  width: 220px;
  height: 40px;
  overflow-y: auto;
  max-height: 50px;
  word-break: break-word;
  overflow-x: visible;
}
.navbar_churchButton__i0K7x:hover {
  background: #81ecec;
  transition-duration: 200ms;
}

.navbar_notChurchButton__N1vNy {
  width: 220px;
  height: 40px;
  margin: 0.7em 0.5em;
  /* padding : .4em 1em; */
  border: 2px solid #ff7675;
  border-radius: 1em;
  color: #ffff;
  background: #d63031;
  cursor: pointer;
  max-width: 220px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.navbar_notChurchButton__N1vNy:hover {
  background: #ff7675;
  transition-duration: 200ms;
}

.navbar_tooltip__a\\+n\\+e {
  /* position: relative; */
  display: inline-block;
}

.navbar_tooltip__a\\+n\\+e .navbar_tooltiptext__WNB4J {
  visibility: hidden;
  width: 320px;
  /* max-height: 40px; */
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding-top: 10px;
  padding: 5px;
  /* Position the tooltip text */
  position: absolute;
  z-index: 1;
  top: 100%;
  left: 18%;
  word-break: break-word;
  white-space: normal;
  overflow-x: visible;
  font-size: 1em;
}

.navbar_logoDiv__s-uOO {
  width: 320px;
  background-color: #248a65;
}

.navbar_tooltip__a\\+n\\+e:hover .navbar_tooltiptext__WNB4J {
  visibility: visible;
  transition-duration: 200ms;
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbar/navbar.module.css"],"names":[],"mappings":"AAEA;EACE,yBAAyB;EACzB,OAAO;EACP,MAAM;EACN,QAAQ;EACR,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,WAAW;AACb;AACA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,4CAA4C;EAC5C,0BAA0B;AAC5B;AACA;EACE,8CAA8C;EAC9C,0BAA0B;AAC5B;AACA;EACE,UAAU;EACV,6BAA6B;EAC7B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;AAClC;;AAEA;EACE,OAAO;EACP,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,8BAA8B;EAC9B,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;;EAEE,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;AAClB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EAExB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,SAAS;EACT,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans&display=swap');\n\n.container {\n  background-color: #22835f;\n  left: 0;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  position: fixed;\n}\n\n.hide {\n  margin-top: -3em;\n  transition-duration: 200ms;\n}\n.show {\n  margin-top: 0;\n  transition-duration: 200ms;\n}\n\n.menuButton {\n  padding: 0.5em;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 2.5em;\n  height: 2em;\n}\n.menuButton div {\n  padding: 0.2em 0.5em;\n  background-color: white;\n  /* border-radius : 1em; */\n  transition-duration: 200ms;\n}\n\n.open .top {\n  transform: translate(0, 0.8em) rotate(45deg);\n  transition-duration: 200ms;\n}\n.open .down {\n  transform: translate(0, -0.8em) rotate(-45deg);\n  transition-duration: 200ms;\n}\n.open .mid {\n  opacity: 0;\n  transform: translate(-1em, 0);\n  transition-duration: 200ms;\n}\n\n.mainBar {\n  display: flex;\n  /* justify-content : space-between; */\n}\n\n.linkList {\n  position: absolute;\n  background-color: #2d3436;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  border-radius: 0 0 1em 1em;\n  overflow: hidden;\n}\n.linkList a {\n  padding: 1em 2em;\n  text-align: start;\n  text-decoration: none;\n  background-color: #2d3436;\n  font-weight: 600;\n  color: white;\n  border-bottom: 1px solid #8395a7;\n}\n\n.openList {\n  left: 0;\n  transition-duration: 200ms;\n}\n\n.closeLink {\n  left: -100%;\n  transition-duration: 200ms;\n}\n\n.unhidden {\n  display: flex;\n}\n\n.hidden {\n  display: none;\n}\n\n.dropdownLinks {\n  flex-direction: column;\n  padding-left: 2em;\n}\n\n.link button {\n  color: white;\n  padding: 1em 2em;\n  background: none;\n  width: 100%;\n  border: none;\n  display: flex;\n  font-weight: 600;\n  border-bottom: 1px solid #8395a7;\n  font-size: 0.95em;\n}\n\n.arrHidden {\n  transform: rotate(0);\n  transition-duration: 300ms;\n}\n\n.arrUnhidden {\n  transform: rotate(90deg);\n  transition-duration: 300ms;\n}\n\n.profile {\n  display: flex;\n  margin-right: 1em;\n  position: relative;\n  margin-left: auto;\n}\n\n.profileDropdown {\n  position: absolute;\n  top: 3.8em;\n  right: 0;\n  transition-duration: 300ms;\n  flex-direction: column;\n  background: #055437;\n  /* background : #00b894; */\n  padding: 0.7em 1em;\n  border-radius: 0 0 0.5em 0.5em;\n  display: flex;\n}\n.profShow {\n  margin-right: 0em;\n  opacity: 1;\n}\n.profHide {\n  margin-right: -100%;\n  opacity: 0;\n}\n.profileDropdown a,\n.profileDropdown button {\n  text-decoration: none;\n  color: white;\n  font-weight: 600;\n  text-align: start;\n  display: flex;\n  padding: 0.2em 0;\n  transition-duration: 150ms;\n  background: none;\n  border: none;\n  font-size: 1.1em;\n}\n.profileDropdown a:hover,\n.profileDropdown button:hover {\n  color: #ffeaa7;\n}\n.icon {\n  width: 2em;\n}\n\n.imgContainer {\n  display: flex;\n  padding: 0.5em;\n}\n.imgContainer img {\n  border-radius: 50%;\n  border: 2px solid white;\n  margin: auto;\n}\n\n.nameContainer {\n  display: flex;\n  margin: auto;\n  color: white;\n  border: none;\n  background: none;\n  font-size: 1.1em;\n}\n\n.churchButton {\n  margin: 0.7em 0.5em;\n  /* padding : .8em 1em; */\n  width: 225px;\n  border: 2px solid #81ecec;\n  border-radius: 1em;\n  /* color : #055437; */\n  color: #ffff;\n  background: none;\n  cursor: pointer;\n  width: 220px;\n  height: 40px;\n  overflow-y: auto;\n  max-height: 50px;\n  word-break: break-word;\n  overflow-x: visible;\n}\n.churchButton:hover {\n  background: #81ecec;\n  transition-duration: 200ms;\n}\n\n.notChurchButton {\n  width: 220px;\n  height: 40px;\n  margin: 0.7em 0.5em;\n  /* padding : .4em 1em; */\n  border: 2px solid #ff7675;\n  border-radius: 1em;\n  color: #ffff;\n  background: #d63031;\n  cursor: pointer;\n  max-width: 220px;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.notChurchButton:hover {\n  background: #ff7675;\n  transition-duration: 200ms;\n}\n\n.tooltip {\n  /* position: relative; */\n  display: inline-block;\n}\n\n.tooltip .tooltiptext {\n  visibility: hidden;\n  width: 320px;\n  /* max-height: 40px; */\n  background-color: #555;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding-top: 10px;\n  padding: 5px;\n  /* Position the tooltip text */\n  position: absolute;\n  z-index: 1;\n  top: 100%;\n  left: 18%;\n  word-break: break-word;\n  white-space: normal;\n  overflow-x: visible;\n  font-size: 1em;\n}\n\n.logoDiv {\n  width: 320px;\n  background-color: #248a65;\n}\n\n.tooltip:hover .tooltiptext {\n  visibility: visible;\n  transition-duration: 200ms;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `navbar_container__v3qie`,
	"hide": `navbar_hide__8qNbu`,
	"show": `navbar_show__UXp4Z`,
	"menuButton": `navbar_menuButton__EPjGt`,
	"open": `navbar_open__bl92B`,
	"top": `navbar_top__+HI2k`,
	"down": `navbar_down__dRLpL`,
	"mid": `navbar_mid__zWmza`,
	"mainBar": `navbar_mainBar__H50ol`,
	"linkList": `navbar_linkList__-rNRS`,
	"openList": `navbar_openList__DWbi5`,
	"closeLink": `navbar_closeLink__lzizO`,
	"unhidden": `navbar_unhidden__78CIS`,
	"hidden": `navbar_hidden__v3vjP`,
	"dropdownLinks": `navbar_dropdownLinks__FtJBf`,
	"link": `navbar_link__SztSH`,
	"arrHidden": `navbar_arrHidden__HaPRv`,
	"arrUnhidden": `navbar_arrUnhidden__3R6EE`,
	"profile": `navbar_profile__xT7+H`,
	"profileDropdown": `navbar_profileDropdown__Z9X5t`,
	"profShow": `navbar_profShow__xHEmN`,
	"profHide": `navbar_profHide__SsP7k`,
	"icon": `navbar_icon__aXGXB`,
	"imgContainer": `navbar_imgContainer__iAVW2`,
	"nameContainer": `navbar_nameContainer__PWQmv`,
	"churchButton": `navbar_churchButton__i0K7x`,
	"notChurchButton": `navbar_notChurchButton__N1vNy`,
	"tooltip": `navbar_tooltip__a+n+e`,
	"tooltiptext": `navbar_tooltiptext__WNB4J`,
	"logoDiv": `navbar_logoDiv__s-uOO`
};
export default ___CSS_LOADER_EXPORT___;
